import type { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/utils';
import { Text } from '../../text';

/**
 * Tableヘッダーセルコンポーネント
 */
type TableHeadProps = ComponentPropsWithRef<'th'> & {
  rowSpan?: number;
  colSpan?: number;
};

export const TableHead = ({
  className,
  ref,
  rowSpan,
  colSpan,
  children,
  ...props
}: TableHeadProps) => (
  <th
    ref={ref}
    rowSpan={rowSpan}
    colSpan={colSpan}
    className={cn(
      'border-border-strength1 border-r bg-surface-strength2 text-left align-middle last:border-r-0 [&:has([role=checkbox])]:pr-0',
      'p-[8px]',
      className,
    )}
    {...props}
  >
    {typeof children === 'string' ? (
      <Text as="span" variant="label" color={'muted'}>
        {children}
      </Text>
    ) : (
      children
    )}
  </th>
);
